import Draggable from './src/draggable.vue'
export default Draggable
